import {Controller} from "@hotwired/stimulus";
import Tribute from "tributejs";

export default class extends Controller {
    static targets = ["input", "hiddenInput"];
    static values = {rows: Array, field: String};

    connect() {
        this.tribute = new Tribute({
            values: this.fetchSuggestions.bind(this),
            trigger: "$",
            containerClass: 'tribute-container',
            selectTemplate: function (item) {
                return `<span class="inline-block bg-purple-100 text-purple-400 rounded px-2 py-0.5 text-xs" contenteditable="false">${item.original.name}</span>`
            },
            menuItemTemplate: function (item) {
                return item.string;
            },
            noMatchTemplate: function () {
                return `<span style="visibility: hidden;"></span>`;
            },
            lookup: 'name',
            requireLeadingSpace: false,
        });
        this.tribute.attach(this.inputTarget);

        // Patch Tribute's range.getWindowSelection to avoid CodeMirror conflict.
        // esbuild bundles CodeMirror's internal getSelection(root) as a top-level function,
        // which shadows window.getSelection() calls in the same bundle scope.
        // Using Document.prototype.getSelection bypasses this scoping issue.
        const nativeGetSelection = Document.prototype.getSelection.bind(document);
        this.tribute.range.getWindowSelection = function() {
            return nativeGetSelection();
        }

        this.preloadValues()
    }


    onBlur(event) {
        let value = this.inputTarget.innerHTML
        value = value.replace(/&nbsp;/g, " ")
        this.inputTarget.innerHTML = value
        let updatedText = this.inputTarget.textContent
        const sortedRows = this.rowsValue.sort((a, b) => b.name.length - a.name.length)
        sortedRows.forEach(row => {
            const escapedName = row.name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
            const regex = new RegExp(escapedName, "g");
            if (regex.test(updatedText)) {
                updatedText = updatedText.replace(regex, row.id);
            }
        });
        this.hiddenInputTarget.value = updatedText;
    }

    fetchSuggestions(text, cb) {
        const suggestions = this.rowsValue

        const filtered = suggestions.filter((item) =>
            item.name.toLowerCase().includes(text.toLowerCase())
        );

        cb(filtered);
    }

    disconnect() {
        this.tribute.detach(this.inputTarget);
    }

    preloadValues() {
        let content = this.inputTarget.dataset.value;
        if (!content) {
            return
        }
        const sortedRows = this.rowsValue.sort((a, b) => b.name.length - a.name.length)
        sortedRows.forEach(row => {
            const regex = new RegExp(row.id, 'g');
            if (regex.test(content)) {
                content = content.replace(regex, `<span class="inline-block bg-purple-100 text-purple-400 rounded px-2 py-0.5 text-xs" contenteditable="false">${row.name}</span>`);
            }
        });
        this.inputTarget.innerHTML = content;
    }
}
